import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import areaChange from 'vue-area-change'
import AwesomeSwiper from 'vue-awesome-swiper'

import '../css/public.css'
import 'swiper/dist/css/swiper.css'

Vue.use(Router)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(AwesomeSwiper)

import HelloWorld from '@/components/HelloWorld'
// 公用头部
import Header from '@/components/common/header'

// 首页
import homepage from '@/components/homepageComponent/homepage'
// 资产定价
import assetsPricing from '@/components/homepageComponent/assetsPricing'
// 反欺诈
import antiFraud from '@/components/homepageComponent/antiFraud'
import data from '../components/common/data.vue'

// const selectCity = r => require.ensure([], () => r(require('components/valuation/selectCity/selectC')), 'group-valuation')
// 首页二期
const index = r => require.ensure([], () => r(require('@/components/indexComponent/index.vue')))
const expect = r => require.ensure([], () => r(require('@/components/common/expect.vue')))

// 下载
const download = r => require.ensure([], () => r(require('@/components/detailComponent/download.vue')))
// 加入我们
const joinUs = r => require.ensure([], () => r(require('@/components/detailComponent/joinUs.vue')))
// 关于我们
const aboutUs = r => require.ensure([], () => r(require('@/components/aboutUsComponent/aboutUs.vue')))



export default new Router({
	mode: "history", //??
	routes: [
		{
		  path: '/',
		  name: 'index',
		  component: index
		},
		{
		  path: '/HelloWorld',
		  name: 'HelloWorld',
		  component: HelloWorld
		},
		{
		  path: '/homepage',
		  name: 'homepage',
		  component: homepage
		},
		{
		  path: '/assetsPricing',
		  name: 'assetsPricing',
		  component: assetsPricing
		},
		{
		  path: '/antiFraud',
		  name: 'antiFraud',
		  component: antiFraud
		},
		{
		  path: '/data',
		  name: 'data',
		  component: data
		},
		{
		  path: '/index',
		  name: 'index',
		  component: index
		},
		{
		  path: '/expect',
		  name: 'expect',
		  component: expect
		},
		{
		  path: '/download',
		  name: 'download',
		  component: download
		},
		{
		  path: '/joinUs',
		  name: 'joinUs',
		  component: joinUs
		},
		{
		  path: '/aboutUs',
		  name: 'aboutUs',
		  component: aboutUs
		}
	]

})



// WEBPACK FOOTER //
// ./src/router/index.js